/**
 * Axios client for Stride API v2 (legacy pages not yet on RTK Query).
 */

import { API_BASE_URL } from '@/config/api'
import { getCsrfToken } from '@/security/csrf'
import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { clearAuthData, getAuthToken } from '@/core/auth'

const apiClient: AxiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api/v2`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
})

apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAuthToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // Client-only token; API uses Bearer auth and does not validate CSRF yet.
    // Header is still sent for future double-submit protection; CORS must allow it.
    const csrfToken = getCsrfToken()
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken
    }
    return config
  },
  (error: AxiosError) => Promise.reject(error)
)

apiClient.interceptors.response.use(
  response => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean }

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true
      clearAuthData()
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login'
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient
